import { render, staticRenderFns } from "./SupplierQuotesItem.vue?vue&type=template&id=4e8df438&"
import script from "./SupplierQuotesItem.vue?vue&type=script&lang=js&"
export * from "./SupplierQuotesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports